export default __webpack_public_path__ + "static/ogg-image-default-b11be390b53a962d42892ce4fac7f6e9.png";